import PolicyLayout from "./PolicyLayout";

export default function ShippingPolicy() {
  return (
    <PolicyLayout title="Shipping and Exchange Policy" updated="March 2026" testId="shipping-page">
      <p>Pawsomeland Foundation is a not-for-profit organisation registered in India (CIN: U88900MP2024NPL070251). We do <strong>not sell or ship physical goods</strong> through this Website. All transactions completed on <strong>pawsomelandfoundation.org</strong> are voluntary donations towards the rescue, treatment, feeding, and sheltering of animals in our care.</p>

      <h2>1. Nature of Transactions</h2>
      <p>Every payment made on this Website falls into one of two categories:</p>
      <ul>
        <li><strong>One-time donation</strong> — a single voluntary contribution.</li>
        <li><strong>Monthly recurring donation</strong> — a fixed amount authorised by you to be auto-debited each month via UPI AutoPay, cards, or net-banking, until you cancel.</li>
      </ul>
      <p>There is no physical product, service, or merchandise being purchased. Therefore, no shipping, delivery, exchange, or return of goods applies.</p>

      <h2>2. Digital Confirmation</h2>
      <p>Upon a successful donation, you will receive a digital acknowledgement — either as an on-screen confirmation, an email receipt from Razorpay, or both. For 80G tax certificates, please write to us as described in our <a href="/terms">Terms and Conditions</a> and Privacy Policy.</p>

      <h2>3. Cancellation of Monthly Donations</h2>
      <p>Monthly recurring donations can be cancelled at any time — full details are on our <a href="/refund-policy">Cancellation and Refund Policy</a> page.</p>

      <h2>4. Refunds</h2>
      <p>In the rare event of a duplicate charge, unauthorised transaction, or accidental donation, refunds are handled as per our <a href="/refund-policy">Cancellation and Refund Policy</a>. Refunds are issued to the original payment method within 7-10 working days of approval.</p>

      <h2>5. Contact</h2>
      <p>If you have any questions related to this policy or a transaction on our Website, please reach us at:</p>
      <p>Email: <a href="mailto:pawsomelandfoundation@gmail.com">pawsomelandfoundation@gmail.com</a><br/>Phone / WhatsApp: <a href="tel:+917477216753">+91 74772 16753</a><br/>Office: House no. 20, Kaveri Tailors, Ganesh Mandir, Chhola Road, Bhopal</p>
    </PolicyLayout>
  );
}
